export interface ListEntityData {
    data?: Array<EntityData>
}

export interface EntityData {
    data?: Entity
}

export interface Entity {
    id?: number,
    name?: string
}

export function find(list?:ListEntityData, id?:number) {
    const foundItem = list && list.data && list.data.find(item => item.data?.id === id)
    return foundItem && foundItem.data
}